var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F7F8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 14,
    fill: "#0516C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 24.75H20.25M15.75 24.75V21M15.75 24.75H11.7C11.5807 24.75 11.4662 24.7026 11.3818 24.6182C11.2974 24.5338 11.25 24.4193 11.25 24.3V21.45C11.25 21.3307 11.2974 21.2162 11.3818 21.1318C11.4662 21.0474 11.5807 21 11.7 21H15.75M20.25 24.75V15.75M20.25 24.75H24.3C24.4193 24.75 24.5338 24.7026 24.6182 24.6182C24.7026 24.5338 24.75 24.4193 24.75 24.3V11.7C24.75 11.5807 24.7026 11.4662 24.6182 11.3818C24.5338 11.2974 24.4193 11.25 24.3 11.25H20.7C20.5807 11.25 20.4662 11.2974 20.3818 11.3818C20.2974 11.4662 20.25 11.5807 20.25 11.7V15.75M15.75 21V16.2C15.75 16.0807 15.7974 15.9662 15.8818 15.8818C15.9662 15.7974 16.0807 15.75 16.2 15.75H20.25",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.61242a4d92f349e833d9cfd7c024d78a.svg";
export { ForwardRef as ReactComponent };